<template>
  <div :class="cn('rounded-lg border border-border bg-white text-foreground shadow-sm', props.class)">
    <slot />
  </div>
</template>

<script setup>
import { cn } from '@/lib/utils'
const props = defineProps({ class: { type: String, default: '' } })
</script>
